window.dataLayer = window.dataLayer || [];
const getFormTitle = (form) => {
    const titleElement = form.querySelector('.Form__Title') || form.querySelector('.Form__Description');
    return titleElement ? titleElement.textContent?.trim() || '' : '';
};
// tag submit buttons being clicked
const handleSubmitBtns = () => {
    const submitBtns = document.querySelectorAll('.FormSubmitButton');
    submitBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
            const form = btn.closest('form');
            if (form) {
                const formTitle = getFormTitle(form);
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'formSubmit',
                        form_type: formTitle,
                    });
                }
            }
        });
    });
};
// tag Next button in stepped form being clicked, send step index
const handleFormProgress = () => {
    const form = document.querySelector('form[data-f-metadata]');
    if (!form)
        return;
    const nextButton = form.querySelector('button[data-f-navigation-next]');
    if (!nextButton)
        return;
    nextButton.addEventListener('click', () => {
        const currentStepIndex = form
            .querySelector('section.Form__Element--NonData:not(.hide)')
            ?.getAttribute('data-f-stepindex');
        const formTitle = getFormTitle(form);
        if (currentStepIndex && window.dataLayer) {
            window.dataLayer.push({
                event: 'formProgress',
                form_type: formTitle,
                form_step: currentStepIndex,
            });
        }
    });
};
//  tag form being started by user by listening for any focus event
//  on form element
const handleFormStart = () => {
    const forms = document.querySelectorAll('form');
    forms.forEach((form) => {
        const handleFocusIn = (event) => {
            const target = event.target;
            if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.tagName === 'SELECT') {
                const formTitle = getFormTitle(form);
                const formStep = target.closest('.Form__Element--NonData')?.getAttribute('data-f-stepindex') || '';
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'formStart',
                        form_type: formTitle,
                        form_step: formStep,
                    });
                }
                form.removeEventListener('focusin', handleFocusIn);
            }
        };
        form.addEventListener('focusin', handleFocusIn);
    });
};
const handleFormDataTagging = () => {
    handleSubmitBtns();
    handleFormProgress();
    handleFormStart();
};
export default handleFormDataTagging;
